import { HttpInterceptor, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { EComService } from './ecom-common.service';
import { EcomCookies } from './ecom-cookies';
import { EComWebStorage } from './ecom-webstorage.services';

@Injectable()
export class Interceptor implements HttpInterceptor {

  constructor(public ecomservice: EComService, private webstorage: EComWebStorage, private cookie: EcomCookies) {
  }
  intercept(req: import("@angular/common/http").HttpRequest<any>, next: import("@angular/common/http").HttpHandler): import("rxjs").Observable<import("@angular/common/http").HttpEvent<any>> {
    let url = req.url.split('?')[0];
    url = url.substr(url.lastIndexOf('/') + 1);
    console.log(url);
    const olaruserRequestAuthorizeUrl = [
      'GetAreaQrCodeDetails',
      'GetLocationSettings',
      'GetSettings',
      'GetOlarDiscounts',
      'GetSettingStores',
      'GetCategoryItems',
      'GetItemsByCategoryId',
      'GetItemsByName',
      'GetVariants',
      'GetItemsFreeByIds',
      'GetItemsUpsell',
      'GetDiscountsByLocationId',
      'GetEntireDiscountsByLocationId',
      'GetSurchargesByLocationId',
      'GetItemDetails',
      'GetItemDetailsByBarcode',
      'UserLogin',
      'UserExist',
      'GetUserDetailsByPhone',
      'GetUserOrderCount',
      'UpdatePassword',
      'GetUpcomingOrderCount',
      'Register',
      'VeriftOtp',
      'GetRequestToken',
      'GetRefreshToken',
      'GetReferredDetails',
      'AddService',
      'InsertOrder',
      'AddReservation',
      'GetReservationStatus',
      'GetDineInCollectionDeliveryStatus',
      'OrderStatusNotify',
      'GetOrderStatus',
      'ImHereStatusNotify',
      'AssistanceNotify',
      'AcceptingOrdersNow',
      'ReferFriend',
      'PrintPreview',
      'SendInvoice',
      'GetDietaryCusines',
      'GetMessageValue',
      'GetSettingsByCordinates',
      'UserExistAndPhoneVerified',
      'SaveUserAddress',
      'GetUserAddresses',
      'GetOlarDiscountsDescription',
      'GetMerchantCustomerLoyalty',
      'JoinLoyaltyProgram',
      'GetCategories',
      'GetSettingByQR',
      'QRUserGetOTP',
      'QRUserVerifyOTP',
      'QRUserPasswordUpdate',
      'GetUserOrderPaymentStatus',
      // 'GetQrPayment',
      'InquiryQr',
      'SaveFPXUser',
      'GetBasicSettings',
      'VerifySocialUser',,
      'GetUserByPkid',
      'GetRewards',
      'GetCustomerLoyalty',
      'GetOrderHistoryByCustomer',
      'GetOrderDetailsById'
    ];
    const olarThirdParyUrl = [
      'GetUserIPAddress'
    ];
    const goGetUrl = [
      'time_check',
      'on_demand_time_check',
      'location_check',
      'check_fee',
      'jobs'
    ];
    const olarAnonymousUrl = [
      'GenerateKeys',
      'GoogleApiTrack',
      'AuthenticateRequest',
      // 'GetBasicSettings',
      'GetGiftcards',
      'CreateGiftCardPayment',
      'GetPurchasedGiftcard',
      'GetGiftcardStatus',
      'ClosePreviousDayOpenedFloat',
      'CheckOpenFloatShift',
      'SaveOpenFloatShift',
      'GetQrPayment',
      'InquiryQr'
    ];
    const olarLoginAuthorizeUrl = [
      'SaveUserData',
      'GetUserData',
      'GetUpcomingRerservations',
      'GetUserOrders',
      'ChangePassword',
      'UpdateLocationRating',
      'IsValidVoucherCode',
      'GetVouchersList',
      'IsValidVoucherCode',
      'VouchersList',
      'VoucherClaim',
      'GetEarnRules',
      'GetOlarPoints',
      'GetOlarSpendRules',
      'GetOlarPointsHistory'
    ];
    if (goGetUrl.indexOf(url) !== -1) {
      const httpHeaders = new HttpHeaders()
        .set('Authorization', 'Token token=J1v_dUVBhLLKVtE1NqqP')
        .set('Content-Type', 'application/json')
        .set('Accept', 'application/json');
      const authReq = req.clone({ headers: httpHeaders });
      return next.handle(authReq);
    } else if (olarLoginAuthorizeUrl.indexOf(url) !== -1) {
      const userip = this.webstorage.localSt_ip;
      const token = this.cookie.cookie_authtoken;
      const httpHeaders = new HttpHeaders()
        .set('Token', token)
        .set('clientIPAddress', userip)
        .set('Content-Type', 'application/json')
        .set('Accept', 'application/json');
      const authReq = req.clone({ headers: httpHeaders });
      return next.handle(authReq);
    } else if (olaruserRequestAuthorizeUrl.indexOf(url) !== -1) {
      const token = this.webstorage.localSt_client_id;
      const userip = this.webstorage.localSt_ip;
      const httpHeaders = new HttpHeaders()
        .set('clientId', token)
        .set('clientIPAddress', userip)
        .set('Content-Type', 'application/json')
        .set('Accept', 'application/json');
      const authReq = req.clone({ headers: httpHeaders });
      return next.handle(authReq);
    } else if (olarAnonymousUrl.indexOf(url) !== -1) {
      const userip = this.webstorage.localSt_ip;
      const httpHeaders = new HttpHeaders()
        .set('clientIPAddress', userip ? userip : "1.32.96.57")
        .set('Content-Type', 'application/json')
        .set('Accept', 'application/json');
      const authReq = req.clone({ headers: httpHeaders });
      return next.handle(authReq);
    } else {
      return next.handle(req);
    }
  }
}
